export const myTz = () => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (tz) {
    return tz
  }
  return 'UTC'
}
